import React, { useEffect } from 'react'

import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from 'src/components/Barcode'

import { convertGS1 } from './utils'

const useStyles = makeStyles({
  label: {
    width: '4in',
    height: '6in',
  },
  zoneA: {
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '1.5in',
    fontSize: '14px',
  },
  zoneB: {
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2.5in',
    fontSize: '14px',
  },
  zoneC: {
    borderTop: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2.5in',
  },
  zoneD: {
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '1.5in',
  },
  zoneE: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '4in',
  },
  zoneF: {
    borderTop: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
  },
  zoneG: {
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2in',
  },
  zoneH: {
    borderTop: '1px solid black',
    height: '2in',
    width: '4in',
  },
  header: {
    fontSize: '12px',
    fontWeight: 'bold',
    paddingLeft: '3px',
  },
  address: {
    lineHeight: '1.0',
    paddingLeft: '10px',
  },
  from: {
    lineHeight: '1.0',
    paddingLeft: '5px',
    fontSize: '10px',
  },
  carrier: {
    fontWeight: 'bold',
    paddingLeft: '5px',
  },
  to: {
    lineHeight: '1.0',
    fontWeight: 'bold',
    paddingLeft: '10px',
  },
  container: {
    top: 'auto',
    bottom: 0,
  },
  center: {
    flexGrow: 1,
    textAlign: 'center',
  },
})

interface HomeDepotLabelProps {
  zoneA: string[]
  zoneB: string[]
  zoneC: string[]
  zoneD: string
  zoneE: string
  zoneF: number[]
  zoneG: number
  zoneH: string
}

interface Props {
  data: HomeDepotLabelProps
  onReadyToPrint?: () => void
}

export const HomeDepotLabel = (props: Props) => {
  const { data, onReadyToPrint } = props
  const ssccBarcode = { barcode: convertGS1(data.zoneH, 2), type: 'gs1-128', displayName: '' }
  const classes = useStyles()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className={`always-page-break ${classes.label}`}>
      <div className="print-page">
        <Box className={classes.label}>
          <Grid container spacing={0}>
            <Grid item>
              <Box className={classes.zoneA}>
                <Typography className={classes.header}>From:</Typography>
                {data.zoneA.map((line) => (
                  <Typography key={line} className={classes.from}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneB}>
                <Typography className={classes.header}>To:</Typography>
                {data.zoneB.map((line) => (
                  <Typography key={line} className={classes.to}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneC}>
                <Typography className={classes.header}>Carrier:</Typography>
                <Typography className={classes.carrier}>{data.zoneC[0]}</Typography>
                <Typography className={classes.carrier}>TMS ID #: {data.zoneC[1]}</Typography>
                <Typography className={classes.carrier}>BOL #: {data.zoneC[2]}</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneD}>
                <Typography className={classes.header}>Store#:</Typography>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Typography>{data.zoneD}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box
                className={classes.zoneE}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="h1">PO: {data.zoneE}</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneF}>
                <Typography className={classes.header}>PALLET NO.:</Typography>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Typography variant="h1">
                    {data.zoneF[0]} of {data.zoneF[1]}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneG}>
                <Typography className={classes.header}>NO. OF CARTONS:</Typography>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Typography variant="h1">{data.zoneG}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box className={`${classes.zoneH} ${classes.container}`}>
                <Typography className={classes.header}>SSCC-18</Typography>
                <Box display="flex" justifyContent="center">
                  <Typography variant="h3">{ssccBarcode.barcode}</Typography>
                </Box>
                <Box ml={5} mr={5}>
                  <Barcode barcode={ssccBarcode} scale={2} height={26} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  )
}
